@if (!isDecryptionFailure()) {
  <button
    [bitAction]="download"
    bitIconButton="bwi-download"
    buttonType="primaryGhost"
    size="small"
    type="button"
    [label]="'downloadAttachmentLabel' | i18n"
  ></button>
}
